import { Reveal } from "@/hooks/useReveal";

const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative bg-white py-28 md:py-40 px-6 md:px-12 overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        {/* Text */}
        <div className="lg:col-span-6 order-2 lg:order-1">
          <Reveal>
            <p className="overline mb-6">About — Manzano Group</p>
          </Reveal>
          <Reveal delay={120}>
            <h2 className="font-heading text-5xl sm:text-6xl lg:text-7xl leading-[1.02] tracking-tight text-black mb-10">
              A team built on
              <em className="italic font-light"> discretion, </em>
              precision, and provenance.
            </h2>
          </Reveal>
          <Reveal delay={240}>
            <div className="silver-rule mb-10" />
          </Reveal>
          <Reveal delay={300}>
            <p className="text-base md:text-lg text-black/70 leading-relaxed max-w-xl mb-6">
              For more than two decades, Manzano Real Estate has represented the most
              consequential properties across California — from the cliffs of Malibu to
              the boulevards of Beverly Hills. Our work is quiet by design and decisive
              by reputation.
            </p>
            <p className="text-base md:text-lg text-black/70 leading-relaxed max-w-xl">
              We are advisors first. Every transaction is shaped by deep market
              intelligence, an architectural eye, and a relentless commitment to the
              client behind the address.
            </p>
          </Reveal>
          <Reveal delay={400}>
            <div className="mt-14 grid grid-cols-3 gap-6 max-w-lg">
              <div data-testid="stat-volume">
                <p className="font-heading text-4xl md:text-5xl text-black">$200M</p>
                <p className="overline mt-2">Volume Sold</p>
              </div>
              <div data-testid="stat-listings">
                <p className="font-heading text-4xl md:text-5xl text-black">500+</p>
                <p className="overline mt-2">Closings</p>
              </div>
              <div data-testid="stat-years">
                <p className="font-heading text-4xl md:text-5xl text-black">25+</p>
                <p className="overline mt-2">Years</p>
              </div>
            </div>
          </Reveal>
        </div>

        {/* Image */}
        <Reveal delay={200} className="lg:col-span-6 order-1 lg:order-2">
          <div className="relative">
            <div className="absolute -top-6 -left-6 w-full h-full bg-[#f0f0f0] hidden md:block" />
            <div className="absolute -bottom-6 -right-6 w-32 h-32 border border-[#c0c0c0] hidden md:block" />
            <img
              data-testid="about-portrait"
              src="/assets/family.jpg"
              alt="Alfredo Manzano with family — Manzano Real Estate"
              className="relative w-full h-[520px] md:h-[640px] object-cover"
            />
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default About;
